<script>
import axios from 'axios';

export default {
  name: 'AvContractWidget',
  data() {
    return {
      avContractData: [{
        name: 'Kunden',
        data: [['AV-Verträge', 0]],
      },
      {
        name: 'abgeschlossene Verträge',
        data: [['AV-Verträge', 0]],
      }],
      av: [{
        name: 'Kunden',
        data: [['AV-Verträge', 0]],
      },
      {
        name: 'abgeschlossene Verträge',
        data: [['AV-Verträge', 0]],
      }],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchCustomerData() {
      return axios.get('/affiliate')
        .then((response) => {
          const affiliates = response.data;
          const customerCount = affiliates
            .map(it => (!it.isDelete ? 1 : 0))
            .reduce((acc, v) => acc + v);

          this.avContractData[0].data[0][1] = customerCount;
        });
    },
    fetchFinishedContractData() {
      return axios.get('/avContract')
        .then((response) => {
          const avContracts = response.data;
          const finishedContractCount = avContracts
            .map(it => (it.contractor ? 1 : 0))
            .reduce((acc, v) => acc + v);

          this.avContractData[1].data[0][1] = finishedContractCount;
        });
    },
    fetchData() {
      axios.all([
        this.fetchCustomerData(),
        this.fetchFinishedContractData(),
      ])
        .then(axios.spread(() => {
          this.avContractData = this.avContractData.slice();
        }));
    },
    openAvContact() {
      this.$router.push('/avContracts');
    },
  },
};
</script>

<template>
  <div>
    <v-card>
      <v-card-title class="av-contract-title"
                    @click="openAvContact">
        <v-icon
          large
          left
        >
          list_alt
        </v-icon>
        <span class="title font-weight-light">AV-Verträge</span>
      </v-card-title>
      <column-chart :data="avContractData" :stacked="true" :colors="['#FB8C00', '#26a73a']" />
    </v-card>
  </div>
</template>

<style lang="scss" scoped>
.av-contract-title {
  cursor: pointer;
}
</style>
